import React from 'react';
import ReactSWF from 'react-swf';
import ReactOnRails from 'react-on-rails';

export default class Matho extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div>
        <ReactSWF
          src="/assets/vt-aplusmath/flash/Matho.swf"
          id="guid_001"
          width="480"
          height="800"
          wmode="transparent"
        />
      </div>
    );
  }
}

ReactOnRails.register({Matho});



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/matho/matho.js
 **/